"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderStateMatcher = void 0;
const interweave_1 = require("interweave");
const react_1 = __importDefault(require("react"));
const typings_1 = require("../../typings");
class ProviderStateMatcher extends interweave_1.Matcher {
    constructor(name, options) {
        super(name, options);
        this.replacementRegex = new RegExp(`(?:\\[\\[|{)(${typings_1.MentionType.provider_state})(?:\\]\\]|})`, 'm');
    }
    match(str) {
        const result = str.match(this.replacementRegex);
        if (!result) {
            return null;
        }
        const val = {
            index: result.index,
            length: result[0].length,
            match: result[1],
            valid: true
        };
        return val;
    }
    replaceWith(children, props) {
        const { replacement } = this.options;
        if (!replacement) {
            return react_1.default.createElement("span", Object.assign({}, props), children);
        }
        return react_1.default.createElement("span", Object.assign({}, props), replacement);
    }
    asTag() {
        return 'span';
    }
}
exports.ProviderStateMatcher = ProviderStateMatcher;
//# sourceMappingURL=ProviderStateMatcher.js.map